import React from 'react';
import { observer } from 'mobx-react-lite';
import { PropertyTypeLabels } from '@producer/properties';
import { ChevronDownIcon } from '@radix-ui/react-icons';

import { SingleSelectDropdown } from '../../../components/select-dropdown';
import classes from './property-type-selector.module.scss';

type PropertyTypeSelectorProps = {
  onChange: (value: string | null) => void;
  value: string | undefined;
};

const propertyTypes = ['small-text', 'long-text', 'number', 'single-select', 'multi-select'];

export const PropertyTypeSelector: React.FC<PropertyTypeSelectorProps> = observer(
  ({ onChange, value }) => {
    const options: React.ComponentProps<typeof SingleSelectDropdown>['options'] =
      propertyTypes.map((propertyType) => ({
        label: PropertyTypeLabels[propertyType],
        value: propertyType,
      })) || [];

    const handlePropertyTypeChange = (value?: string) => {
      onChange(value || null);
    };

    return (
      <SingleSelectDropdown
        trigger={(label) => (
          <div className={classes.Select} tabIndex={0}>
            <div>{label || 'Select property type'}</div>
            <div>
              <ChevronDownIcon />
            </div>
          </div>
        )}
        title="Property Type"
        value={value}
        options={options}
        onValueChange={handlePropertyTypeChange}
      />
    );
  },
);
